module.exports = __webpack_public_path__ + "static/media/bg-reina.1fb8bdf0.svg";